




import { usePathAndData } from "../../../hook/usePathAndData"; // Hook para obtener el path y los datos relacionados.
import { AppLayout } from "../../layout/AppLayout"; // Componente de diseño principal.
import { CrearAgenda } from "../../view/Agendas/crear/CrearAgenda";
import { EditarAgenda } from "../../view/Agendas/editar/AgendaEditar";
import AgendaPersonal from "../../view/Agendas/personal/AgendaPersonal";
import { ReporteAgenda } from "../../view/Agendas/reporte/ReporteAgenda";
import AgendaVer from "../../view/Agendas/ver/AgendaVer";




/**
 * Componente de la página de calendario.
 * Renderiza diferentes vistas del calendario según el path actual.
 */
export const PageAgenda = () => {
    const { path } = usePathAndData(); // Obtiene el path actual utilizando el hook personalizado.

    return (
        <AppLayout>
            {" "}
            {/* Contenedor principal con diseño de la aplicación. */}
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {/* Renderiza la lista del calendario si el path es 'calendario/lista'. */}
                                {path[1] === "agenda" && path[2] === "vendedoras" && <AgendaVer />}
                                {/* Renderiza la vista de agenda si el path es 'agenda/ver'. */}
                                {path[1] === "agenda" && path[2] === "crear" && <CrearAgenda />}
                                {/* Renderiza la vista de agenda si el path es 'agenda/crear'. */}
                                {path[1] === "agenda" && path[2] === "personal" && <AgendaPersonal />}


                                {path[1] === "agenda" && path[2] === "editar" && <EditarAgenda />}

                                {/* Renderiza la vista de edición de agenda si el path es 'agenda/editar'. */}
                                {path[1] === "agenda" && path[2] === "reporte" && <ReporteAgenda />}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
